export type GlossaryItem = {
  title: string;
  description: string;
  triggers: Array<string>;
};
